module.exports = __webpack_public_path__ + "static/media/formulare_patrat.e9974b2e.png";